import { Observable } from 'rxjs';
import httpService from './httpService';
import { DriverLocation } from '../data/models/driver-location.model';
import { Driver } from '../data/models/driver.model';
import { PagedList } from '../data/models/paged-list.model';

class DriverService {
  private readonly apiBaseF1;
  private readonly apiBaseTransport;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBaseF1 = __environment__.REACT_APP_DRIVER_API_F1_URL.trim();
    this.apiBaseTransport = __environment__.REACT_APP_DRIVER_API_F1_URL.trim();
  }

  public getDriverLocation(driverID: number): Observable<DriverLocation> {
    const url = `${this.apiBaseF1}/${driverID}/location`;
    return httpService.getJSON(url);
  }

  public getDriversByProvider(
    providerId: number,
  ): Observable<PagedList<Driver>> {
    return httpService.getJSON(
      `${this.apiBaseTransport}/optimized?provider=${providerId}&pageSize=1000`,
    );
  }
}

const driverService = new DriverService();

export default driverService;
